<ng-container *ngIf="sorterTabs">
  <ng-container *ngTemplateOutlet="sorterTabType; context: { filter: sorterTabs }"></ng-container>
</ng-container>

<ng-container *ngFor="let barFilter of barFilters">
  <ng-container *ngIf="isCheckboxFilter(barFilter)">
    <ng-container *ngTemplateOutlet="checkboxFilterType; context: { filter: barFilter }"></ng-container>
  </ng-container>
  <ng-container *ngIf="isRangeFilter(barFilter)">
    <ng-container *ngTemplateOutlet="rangeFilterType; context: { filter: barFilter, range: getCheckedRanges(barFilter.type) }">
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #rangeFilterType let-filter='filter' let-range="range">
  <ng-container [ngSwitch]="filter.type">
    <ng-container *ngSwitchCase="filterTypes.PriceRange">
      <app-filter-bar-tag
        [style.order]="filter.order"
        [class.item-active]="isActiveRange(filter.type)"
        [class.is-multiple]="true"
        [isActive]="isActiveRange(filter.type)"
        [label]="getFilterLabel(filter, range)"
        [isMultipleSelection]="true"
        [icon]="filterBarIcons[filter?.type]"
        (clickEvent)="rangeTrigger(filter, true)">
      </app-filter-bar-tag>
    </ng-container>

    <ng-container *ngSwitchCase="filterTypes.DepartureTimes">
      <ng-container *ngTemplateOutlet="complexRangeFilter; context: { filter: filter, range: range }"></ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="filterTypes.SectorDurations">
      <ng-container *ngTemplateOutlet="complexRangeFilter; context: { filter: filter, range: range }"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #checkboxFilterType let-filter='filter'>
  <app-filter-bar-tag
    *ngIf="showDirectFlightsCheckboxFilter(filter.value)"
    [style.order]="filter.order"
    [class.item-active]="isActiveCheckboxOption(filter.value)"
    [class.is-multiple]="isMultipleSelection(filter)"
    [isActive]="isActiveCheckboxOption(filter.value)"
    [label]="getFilterLabel(filter)"
    [isMultipleSelection]="isMultipleSelection(filter)"
    [icon]="filterBarIcons[filter?.type]"
    (clickEvent)="checkboxTrigger(filter)">
  </app-filter-bar-tag>
</ng-template>

<ng-template #sorterTabType let-filter='filter'>
  <app-filter-bar-tag [class]="'order'"
    [class.item-active]="isActiveSorter"
    [isActive]="isActiveSorter"
    [label]="getFilterLabel(filter)"
    [icon]="icons.SwapVert"
    [isMultipleSelection]="true"
    (clickEvent)="sortTrigger(filter)">
  </app-filter-bar-tag>
</ng-template>

<ng-template #complexRangeFilter let-filter="filter" let-range="range">
  <ng-container *ngIf="isActiveRange(filter.type); else disabledComplexRangeFilter">
    <ng-container *ngFor="let r of range | keyvalue">
      <app-filter-bar-tag
        [style.order]="filter.order"
        [class.item-active]="true"
        [class.is-multiple]="true"
        [isActive]="true"
        [label]="getFilterLabel(filter, r.value, r.key)"
        [icon]="filterBarIcons[filter?.type]"
        [isMultipleSelection]="true"
        (clickEvent)="rangeTrigger(filter, true)">
      </app-filter-bar-tag>
    </ng-container>
  </ng-container>
  <ng-template #disabledComplexRangeFilter>
    <app-filter-bar-tag
      [style.order]="filter.order"
      [class.item-active]="false"
      [class.is-multiple]="true"
      [isActive]="false"
      [label]="getFilterLabel(filter)"
      [isMultipleSelection]="true"
      [icon]="filterBarIcons[filter?.type]"
      (clickEvent)="rangeTrigger(filter, true)">
    </app-filter-bar-tag>
  </ng-template>
</ng-template>